'use strict';

exports.__esModule = true;

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var defaultWrapperStyle = {
  position: 'relative',
  display: 'inline-block'
};

var defaultFontStyle = {
  whiteSpace: 'nowrap',
  fontSize: '60px',
  color: 'white',
  textShadow: '-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black'
};

var defaultActiveStyle = _extends({}, defaultFontStyle, {
  position: 'absolute',
  left: 0,
  top: 0,
  color: 'blue',
  overflow: 'hidden',
  zIndex: 1,
  textShadow: '-2px 0 white, 0 2px white, 2px 0 white, 0 -2px white'
});

var KaraokeLyric = (function (_Component) {
  _inherits(KaraokeLyric, _Component);

  function KaraokeLyric() {
    _classCallCheck(this, KaraokeLyric);

    _Component.apply(this, arguments);
  }

  KaraokeLyric.prototype.render = function render() {
    var _props = this.props;
    var percentage = _props.percentage;
    var text = _props.text;
    var _props2 = this.props;
    var wrapperStyle = _props2.wrapperStyle;
    var fontStyle = _props2.fontStyle;
    var activeStyle = _props2.activeStyle;

    wrapperStyle = wrapperStyle ? _extends({}, defaultWrapperStyle, wrapperStyle) : defaultWrapperStyle;
    fontStyle = fontStyle ? _extends({}, defaultFontStyle, fontStyle) : defaultFontStyle;
    activeStyle = activeStyle ? _extends({}, defaultActiveStyle, activeStyle, {
      width: percentage + '%'
    }) : _extends({}, defaultActiveStyle, {
      width: percentage + '%'
    });

    return _react2['default'].createElement(
      'div',
      { style: wrapperStyle },
      _react2['default'].createElement(
        'div',
        { style: fontStyle },
        text
      ),
      _react2['default'].createElement(
        'div',
        { style: activeStyle },
        text
      )
    );
  };

  _createClass(KaraokeLyric, null, [{
    key: 'propTypes',
    value: {
      text: _react.PropTypes.string.isRequired,
      percentage: _react.PropTypes.number.isRequired,
      fontStyle: _react.PropTypes.object,
      activeStyle: _react.PropTypes.object,
      wrapperStyle: _react.PropTypes.object
    },
    enumerable: true
  }]);

  return KaraokeLyric;
})(_react.Component);

exports['default'] = KaraokeLyric;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-karaoke-lyric/lib/index.js
 ** module id = 106
 ** module chunks = 0
 **/